<!-- =============
Màn hình hiển thị danh sách bộ lọc 
Author: hvanh - 16.1.2024
===============-->
<template>
	<div class="filter-menu">
		<div class="filter-box-show" v-if="isShowBox">
			<div class="filter-conditions">
				<div
					class="filter-display filter-item"
					v-for="(filter, index) in listDataShow"
					:key="index"
				>
					<div class="filter-item-title" v-if="filter.title">
						{{ filter.title }}:
					</div>
					<div
						class="filter-item-text"
						v-html="filter.displayFilter"
						v-tooltip="filter.tooltip"
					></div>
					<div
						class="filter-item-more"
						v-tooltip="{ content: filter.more }"
						v-if="filter.more"
					>
						...
					</div>
					<div
						class="cusor-pointer mi-new-v2 mi-16 mi-icon-v2-close-16 ms-mgl-4px"
						v-if="filter.action"
						@click="handleClickDelete(filter.type)"
					></div>
				</div>
			</div>
			<div class="view-more-filter">
				<div
					class="count-filter-hide"
					v-if="countFilterHide > 0"
					@click="handleShowBoxFilterHide"
				>
					<div class="hide-number">+{{ countFilterHide }}</div>
					<div class="mi-new mi-16 mi-icon-arrow-down-bold-16"></div>
				</div>
				<div class="delete-all" @click="removeAllFilter" v-if="isShowDeleteAll">
					{{ $t('i18nComponent.HeaderOptionFilter.UnFilter') }}
				</div>
			</div>
		</div>
		<div class="filter-box-hide" v-if="!isShowBox">
			<div class="filter-conditions filter-conditions-hide">
				<div
					class="filter-display filter-item"
					v-for="(filter, index) in listData"
					:key="index"
				>
					<div class="filter-item-title" v-if="filter.title">
						{{ filter.title }}:
					</div>
					<div
						class="filter-item-text"
						v-html="filter.displayFilter"
						v-tooltip="filter.tooltip"
					></div>
					<div
						class="filter-item-more"
						v-tooltip="{ content: filter.more }"
						v-if="filter.more"
					>
						...
					</div>
					<div
						class="cusor-pointer mi-new-v2 mi-16 mi-icon-v2-close-16 ms-mgl-4px"
						v-if="filter.action"
						@click="handleClickDelete(filter.type)"
					></div>
				</div>
			</div>
			<div class="hide-more-filter">
				<div class="delete-all" @click="removeAllFilter">
					{{ $t('i18nComponent.HeaderOptionFilter.UnFilter') }}
				</div>
				<div class="toggle-hide-box" @click="handleHideBoxFilter">
					{{ $t('i18nInvoice.InvoiceInbot.Hide') }}
					<div class="mi-new mi-16 mi-icon-arrow-down-bold-16 icon-hide"></div>
				</div>
			</div>
		</div>
	</div>
</template>
  <script>
export default {
	name: 'msDisplayFilter',
	emit: ['actionClick'],
	props: {
		/**
         * Danh sách filter 
         * Ví dụ: [{title: me.$t('i18nInvoice.InvoiceInbot.ReceiveInvoice'),
					displayFilter: `<div class="filter-display">
							${ me.listReceiveTypeFilterStr}
						</div>` ,
					type: 'TypeInvoiceReceive',
					action: 'close',
					more: me.listReceiveTypeFilterHiddenStr},]
         * title: Tến của điều kiện lọc
         * displayFilter: Các điều kiện lọc (dạng html)
         * type: Dạng type của điều kiện lọc
         * action: trạng thái của button
         * more: dạng 3 chấm khi hover vào hiển thị phần truyền vào (dạng string)
         */
		listData: {
			type: Array,
			default: [],
		},
		isShowDeleteAll: {
			type: Boolean,
			default: true,
		},
	},
	watch: {
		listData: {
			handler(newVal) {
				if (newVal) {
					this.hanleListData();
				}
			},
		},
	},
	created() {
		window.addEventListener('resize', this.onResize);
		this.hanleListData();
	},
	data() {
		return {
			listDataShow: [],
			listDataHidden: [],
			countFilterHide: 0,
			isShowBox: true,
			countItemList: 4,
		};
	},
	computed: {},
	methods: {
		handleClickDelete(type) {
			const me = this;
			me.$emit('actionClick', type);
			if (me.countFilterHide > 0) {
				me.countFilterHide -= 1;
			} else {
				me.countFilterHide = 0;
			}
		},
		handleShowBoxFilterHide() {
			this.isShowBox = false;
		},
		removeAllFilter(isEmitAction = true) {
			const me = this;
			if (isEmitAction) {
				me.$emit('actionClick', 'All');
			}
			me.isShowBox = true;
			me.countFilterHide = 0;
		},
		handleHideBoxFilter() {
			this.isShowBox = true;
		},
		hanleListData() {
			const me = this;
			if (!me.listData || me.listData.length <= 0) {
				me.listDataShow = [];
				return;
			}
			if (me.listData.length == 1) {
				me.isShowBox = true;
			}

			me.listDataShow = [];
			//Nếu màn hình nhỏ hơn
			me.checkWidthScreen();

			if (me.listData.length <= me.countItemList) {
				me.listDataShow = me.listData;
			} else {
				for (let i = 0; i < me.countItemList; i++) {
					me.listDataShow.push(me.listData[i]);
				}
				me.countFilterHide = me.listData.length - me.countItemList;
			}
		},
		onResize() {
			let me = this;
			me.$nextTick(() => {
				//Tính toán lại số lượng phần tử
				me.hanleListData();
			});
		},
		/**
		 * Check xem màn hình hiện tại là bao nhiêu
		 */
		checkWidthScreen() {
			let me = this;
			if (window.innerWidth <= 1500) {
				me.countItemList = 1;
			} else if (window.innerWidth <= 1600) {
				me.countItemList = 2;
			} else if (window.innerWidth <= 1700) {
				me.countItemList = 3;
			} else if (window.innerWidth <= 1800) {
				me.countItemList = 4;
			} else {
				me.countItemList = 5;
			}
		},
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/msDisplayFilter.scss';

@media screen and (max-width: 1366px) {
	.filter-menu .filter-box-hide {
		width: 550px;
	}
}
</style>
  
  